import { Image, Spinner } from "@wayflyer/flyui";
import { IconBank24Line } from "@wayflyer/flyui-icons/24/line";
import type { BankConnectionLogo } from "bankconnect";
import { styled } from "styled-components";

type BankLogoDisplayProps = {
  logoState?: BankConnectionLogo;
};

export const SmallImage = styled(Image)`
  height: 24px;
`;

export const BankLogoDisplay = ({ logoState }: BankLogoDisplayProps) => {
  if (!logoState || logoState.loading) {
    return <Spinner size={16} variant="monochrome" />;
  } else if (!logoState.loading && logoState.couldLoad && logoState.data) {
    const srcPrefix = logoState.type === "url" ? "" : "data:image/png;base64,";
    return <SmallImage src={`${srcPrefix}${logoState.data}`} alt="" />;
  } else {
    return <IconBank24Line />;
  }
};
